import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from '@portal-core/auth/services/auth.service';
import { catchError, map, Observable, of } from 'rxjs';

export const authUserDataGuard: CanActivateFn = (): Observable<boolean> => {
  const authService = inject(AuthService);

  return authService.getUser$().pipe(
    map(() => true),
    catchError(() => {
      return of(true);
    })
  );
};
